const url =
  process.env.NODE_ENV === "production"
    ? `https://orders.balkan1936.co.il/`
    : `https://orders.balkan1936.co.il/`;

module.exports = {
  baseUrl: url,
  paymentLink: "https://app.chex.co.il/terminal/511325573",
  customerDevelopmentUrl: "https://flow.iforms.co.il/Show_form/qq70d4ttp5w0cw0w444gw0wwwws0kg",
  newOrderUrl: (passkey, userPhone, cust, agent, orderId) => {
    return `${url}passkey?passkey=${passkey}&phone=${userPhone}&cust=${cust}&agent=${agent}${
      orderId ? `&orderId=${orderId}` : ""
    }`;
  },
};
